// src/components/mobile/TicketLineAdminMobile.jsx
import React, { useContext } from "react";
import { Box, Typography, Chip, Avatar, IconButton } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { LanguageContext } from "../../context/LanguageContext";
import { statusColors } from "../../constants/statusColors";

export default function TicketLineAdminMobile({
  ticket,
  projectName,
  onEdit,
  onDelete,
  creator,
}) {
  const { translate } = useContext(LanguageContext);
  const statusBg = statusColors[ticket.status] || "#ccc";

  return (
    <Box
      onClick={() => onEdit && onEdit(ticket)}
      sx={{
        p: 1,
        mb: 1,
        borderRadius: 1,
        bgcolor: "background.paper",
        boxShadow: 1,
        cursor: "pointer",
      }}
    >
      {/* En-tête : projet + actions */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={0.5}
      >
        <Typography variant="caption" color="text.secondary">
          {projectName}
        </Typography>
        <Box>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onEdit && onEdit(ticket);
            }}
          >
            <Edit fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onDelete && onDelete(ticket.id);
            }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      {/* Ligne principale : avatar + n° + titre */}
      <Box display="flex" alignItems="center" mb={0.5}>
        <Avatar src={creator.photoUrl} sx={{ width: 24, height: 24, mr: 1 }} />
        <Typography variant="body2" noWrap sx={{ flex: 1, fontWeight: 500 }}>
          {ticket.ticketNumber} — {ticket.ticketName}
        </Typography>
      </Box>

      {/* Priorité & Statut */}
      <Box display="flex" justifyContent="space-between">
        <Chip
          label={translate(ticket.priority)}
          size="small"
          sx={{ textTransform: "capitalize" }}
        />
        <Chip
          label={translate(ticket.status)}
          size="small"
          sx={{
            bgcolor: statusBg,
            color: "#fff",
            textTransform: "capitalize",
          }}
        />
      </Box>
    </Box>
  );
}
